import { createUrl } from "@touchtech/web-api-client";

import { WidgetType } from "@is/types";
import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createStylesUrl = () => createUrl(baseUrl, "api/instore/styles");

export const createSearchStylesUrl = () =>
  createUrl(baseUrl, "api/instore/styles/search");

export const createStyleDetailsUrl = (
  styleId: string,
  sizesAndLengths: string
) => createUrl(baseUrl, `api/instore/styles/${styleId}${sizesAndLengths}`);

export const createStyleDetailsEanUrl = (ean: string) =>
  createUrl(baseUrl, `api/instore/Styles/by-ean/${ean}`);

export const createStoreLanguageUrl = (storeId: string) =>
  createUrl(baseUrl, `api/instore/stores/${storeId}/language`);

export const createStoreScannerUrl = ({
  storeId,
  deviceId,
}: {
  storeId: string;
  deviceId: string;
}) => createUrl(baseUrl, `api/stores/${storeId}/devices/${deviceId}/scanner`);

export const createStoreDeviceInstoreUrl = ({
  storeId,
  deviceId,
}: {
  storeId: string;
  deviceId: string;
}) => createUrl(baseUrl, `api/stores/${storeId}/devices/${deviceId}/instore`);

export const createWidgetUrl = (widgetType: WidgetType) => {
  const widgetUrlMap = {
    [WidgetType.SimilarProducts]: "api/instore/styles/similar",
    [WidgetType.CompleteLook]: "api/instore/styles/complete-look",
    [WidgetType.ShopLook]: "api/instore/styles/shop-look",
    [WidgetType.HowAboutThese]: "api/instore/styles/how-about-these",
    [WidgetType.HowToWearIt]: "api/instore/styles/how-to-wear-it",
  };

  return createUrl(baseUrl, widgetUrlMap[widgetType]);
};

export const createStylesAllMediaUrl = () =>
  createUrl(baseUrl, "api/instore/styles/all-media");

export const createStoreCountriesUrl = (storeId: string) =>
  createUrl(baseUrl, `api/instore/stores/${storeId}/countries/3alphacode`);

export const createDeliveryCountriesUrl = () =>
  createUrl(baseUrl, "api/instore/stores/delivery-countries");

export const createStoreCurrenciesUrl = () =>
  createUrl(baseUrl, `api/instore/stores/currencies`);

export const createDeviceIsActiveUrl = (storeId: string, deviceId: string) =>
  createUrl(
    baseUrl,
    `api/instore/stores/${storeId}/devices/${deviceId}/isactive`
  );

export const createCollectionsByStoreUrl = (storeId: string) =>
  createUrl(baseUrl, `api/instore/stores/collections/by-store/${storeId}`);

export const createNewCollection = () =>
  createUrl(baseUrl, `api/instore/stores/collections`);

export const createCollectionByIdUrl = (collectionId: string) =>
  createUrl(baseUrl, `api/instore/stores/collections/${collectionId}`);

export const createCollectionByIdAddItemUrl = (collectionId: string) =>
  createUrl(baseUrl, `api/instore/stores/collections/${collectionId}/add-item`);

export const createCollectionByIdRemoveItemUrl = (
  collectionId: string,
  index: number
) =>
  createUrl(
    baseUrl,
    `api/instore/stores/collections/${collectionId}/remove-at/${index}`
  );

export const createCollectionStylesByIdUrl = (collectionId: string) =>
  createUrl(
    baseUrl,
    `api/instore/stores/collections/${collectionId}/styles/search`
  );

export const createAllFavoriteUrl = (storeId: string) =>
  createUrl(
    baseUrl,
    `api/instore/stores/collections/by-store/${storeId}/all-view`
  );

export const createDemoCollectionByStoreUrl = (storeId: string) =>
  createUrl(baseUrl, `api/instore/stores/collections/demo/by-store/${storeId}`);

export const createCollectionDemoUrl = (collectionId: string) =>
  createUrl(baseUrl, `api/instore/stores/collections/${collectionId}/demo`);

export const createCollectionCheckoutSuggestionsUrl = (collectionId: string) =>
  createUrl(
    baseUrl,
    `api/instore/stores/collections/${collectionId}/checkout-suggestions`
  );

export const createCollectionsReorderUrl = (storeId: string) =>
  createUrl(
    baseUrl,
    `api/instore/stores/collections/by-store/${storeId}/reorder`
  );
